import React from 'react';
import { useHistory } from 'react-router-dom';
import { Grid, Modal } from '@material-ui/core';
import { ModalCancelButton, ModalDeleteButton } from './style/style';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

type Tprops = {
  title: string;
  message: string;
  func: any;
  fileCount?: number;
  openAlertModal: boolean;
  setOpenAlertModal: React.Dispatch<React.SetStateAction<boolean>>;
};

export const DeleteAlertModal: React.FC<Tprops> = (props: Tprops) => {
  const { title, message, func, fileCount, openAlertModal, setOpenAlertModal } =
    props;

  const classes = useStyles();
  const history = useHistory();

  return (
    <Modal
      open={openAlertModal}
      onClose={() => setOpenAlertModal(false)}
      aria-labelledby='simple-modal-title'
      aria-describedby='simple-modal-description'
      className={classes.container}
    >
      <Grid container className={classes.subpaper}>
        {fileCount ? (
          /*フォルダ内に登録件数がある場合 */
          <Grid item xs={12} className={classes.container}>
            <div className={classes.modalHeader}>
              <h1 className={classes.modalTitle}>
                「{message}」{title}を削除
              </h1>
              {history.location.pathname === '/files' && (
                <p>
                  <span>{fileCount}</span>件の書類が削除されます
                </p>
              )}
              {history.location.pathname === '/pictures' && (
                <p>{fileCount}件の写真が削除されます。</p>
              )}
              <p>このフォルダを削除しますか？</p>
              <p>この操作は取り消せません</p>
            </div>
          </Grid>
        ) : (
          /*フォルダ内に登録件数が無い場合 */
          <Grid item xs={12} className={classes.container}>
            <div style={{ textAlign: 'center' }}>
              <h1 style={{ margin: 24, fontSize: 24 }}>{title}を削除</h1>
              <p>「{message}」を削除しますか？</p>
            </div>
          </Grid>
        )}

        <Grid item xs={12} className={classes.modalFooter}>
          <ModalCancelButton
            variant='contained'
            onClick={() => {
              setOpenAlertModal(false);
            }}
          >
            キャンセル
          </ModalCancelButton>
          <ModalDeleteButton
            variant='contained'
            onClick={() => {
              func();
              setOpenAlertModal(false);
            }}
          >
            削除する
          </ModalDeleteButton>
        </Grid>
      </Grid>
    </Modal>
  );
};

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      // モーダルを中央に
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    paper: {
      // モーダル内部
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(2),
      boxShadow: theme.shadows[5],
      width: '70%',
      overflow: 'hidden'
    },
    subpaper: {
      // モーダル内部
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(2),
      boxShadow: theme.shadows[5],
      width: '80%'
    },
    modalHeader: {
      textAlign: 'center',
      paddingBottom: 24,
      '& > p': {
        color: '#ff1212',
        margin: 0,
        '& > span': {
          fontSize: 24
        }
      }
    },
    modalTitle: {
      // モーダル上部
      fontWeight: 'bold',
      marginTop: 32,
      marginBottom: 20,
      fontSize: 16
    },
    modalLeft: {
      // モーダル左側
      padding: 30
    },
    modalRight: {
      // モーダル右側
      padding: 30
    },
    pictureArea: {
      // モーダル右側
      padding: 30,
      paddingLeft: 60
    },
    modalFooter: {
      // モーダル下部
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderTop: '1px solid #cfcfcf',
      padding: 30
    },
    tableHead: {
      //入力フォームラベル
      fontWeight: 'normal',
      textAlign: 'left',
      paddingRight: 24,
      paddingLeft: 24
    },
    tableBody: {
      //入力フォーム右列
      minWidth: 240,
      width: '100%'
    },
    description: {
      //入力フォームラベル
      width: '100%'
    },
    selectBoxStyle: {
      WebkitAppearance: 'menulist-button',
      backgroundColor: 'white',
      border: '1px solid #ced4da',
      fontSize: 16,
      padding: '10px 26px 10px 12px',
      height: 48,
      width: '100%',
      borderRadius: 4,
      color: '#52555f'
    }
  })
);
